const companyController = (function () {
    "use strict";

    const main = {
        postComment: function (params) {
            return $.post('/@comment/add', {
                bedrift: params.bedrift,
                user: params.user,
                rating: params.rating,
                name: params.name,
                text: params.text,
            });
        },
        deleteComment: (id) => {
            return $.post('/@comment/delete/' + id);
        },
        editComment: (id, params) => {
            return $.post('/@comment/edit/' + id, {
                bedrift: params.bedrift,
                user: params.user,
                rating: params.rating,
                name: params.name,
                text: params.text,
            });

        }
    };

    return main;

})();